// extracted by mini-css-extract-plugin
export var textInput = "_dp-0";